export default {
  datetimePickerContainer: {
    marginTop: 16,
    marginBottom: 8,
  },
  datetimePicker: { width: '100%' },
  yesNoForm: {
    marginLeft: 4,
    marginTop: 16,
    marginBottom: 8,
  },
  radioGroup: { marginBottom: -6 },
  eventDataIcon: { color: 'black' },
};

